<template>
  <div class="content-wrapper">
    <!-- <layout></layout> -->
    <crumbs :trails="trails" ref="crumbs"></crumbs>
    <div class="financial-flow">
      <div class="filter-search" ref="searchData">
        <el-form :inline="true" :model="searchData" ref="searchForm">
          <el-form-item label="广告主ID：">
            <el-input onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8" maxlength="9" type="text" size="small" v-model.number="searchData.UserId" clearable placeholder="请输入广告主ID"></el-input>
          </el-form-item>
          <el-form-item label="打款账户：">
            <el-input size="small" v-model="searchData.PaymentAccount" clearable placeholder="请输入打款账户"></el-input>
          </el-form-item>
          <el-form-item label="销售归属：">
            <el-select size="small" v-model="searchData.OrgCode" placeholder="请选择">
              <el-option label="全部" value="-1"></el-option>
              <el-option label="巨掌" value="1"></el-option>
              <el-option label="小果" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="销售：">
            <el-select size="small" v-model="searchData.SalesmanId" placeholder="请选择">
              <el-option label="全部" value="-1"></el-option>
              <template v-for="item in  salerUserList">
                <el-option :label="item.UserName" :value="item.UserId" :key="item.UserId"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="客户身份：">
            <el-select size="small" v-model="searchData.UserSource" placeholder="请选择">
              <el-option label="全部" value="-1"></el-option>
              <el-option label="代理商" value="1"></el-option>
              <el-option label="子账户" value="2"></el-option>
              <el-option label="直客" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="数据类型：">
            <el-select size="small" v-model="searchData.DataType" placeholder="请选择">
              <el-option label="全部" value="-1"></el-option>
              <el-option label="充值金额" value="1"></el-option>
              <el-option label="返点金额" value="2"></el-option>
              <el-option label="分配金额" value="3"></el-option>
              <el-option label="回拨金额" value="4"></el-option>
              <el-option label="余额核减" value="5"></el-option>
              <el-option label="返点核减" value="6"></el-option>
              <el-option label="退款金额" value="7"></el-option>
              <el-option label="消耗扣款" value="8"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="统计时间：">
            <el-date-picker size="small" v-model="searchData.applyTime" value-format="yyyy-MM-dd" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="getFinancialRecordList(1)">搜索</el-button>
            <a class="export-button" :href="exportUrl">导出数据</a>
          </el-form-item>
        </el-form>
      </div>
      <div class="data-type" ref="dataType">
        <span class="el-icon-edit-outline data-size"> 财务记录（ 共{{dataSize}}条 ）</span>
      </div>
      <!-- 数据列表 -->
      <div class="data-list" ref="dataList">
        <el-table :max-height="maxTableHeight" :data="tableData" stripe style="width: 100%">
          <el-table-column align="center" prop="AddDate" :formatter="formatDater" label="统计时间" min-width="180">
          </el-table-column>
          <el-table-column align="center" prop="UserId" :formatter="formatData" label="广告主ID" min-width="150">
          </el-table-column>
          <el-table-column align="center" :formatter="formatData" show-overflow-tooltip prop="UserSourceStr" label="客户身份" min-width="150">
          </el-table-column>
          <el-table-column align="center" :formatter="formatData" show-overflow-tooltip prop="PaymentAccount" label="打款账户" min-width="150">
          </el-table-column>
          <el-table-column align="center" :formatter="formatData" show-overflow-tooltip prop="SalesmanName" label="销售" min-width="150">
          </el-table-column>
          <el-table-column align="center" :formatter="formatData" show-overflow-tooltip prop="OrgCode" label="销售归属" min-width="150">
          </el-table-column>
          <el-table-column align="center" :formatter="formatData" show-overflow-tooltip prop="RechargeAmount" label="充值金额" min-width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.RechargeAmount === 0">-</span>
              <span v-else-if="scope.row.UserSource === 1 || scope.row.UserSource === 0" style="color: #8bc34a">+{{ scope.row.RechargeAmount }}</span>
              <span v-else>{{ scope.row.RechargeAmount }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" :formatter="formatData" show-overflow-tooltip prop="RebateAmount" label="返点金额" min-width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.RebateAmount === 0">-</span>
              <span v-else-if="scope.row.UserSource === 1 || scope.row.UserSource === 0" style="color: #8bc34a">+{{ scope.row.RebateAmount }}</span>
              <span v-else>{{ scope.row.RebateAmount }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" :formatter="formatData" show-overflow-tooltip prop="AllocationAmount" label="分配金额" min-width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.AllocationAmount === 0">-</span>
              <span v-else-if="scope.row.UserSource === 2" style="color: #8bc34a">+{{ scope.row.AllocationAmount }}</span>
              <span v-else-if="scope.row.UserSource === 1">-{{ scope.row.AllocationAmount }}</span>
              <span v-else>{{ scope.row.AllocationAmount }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" :formatter="formatData" show-overflow-tooltip prop="ConsumptionDeduction" label="消耗扣款" min-width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.ConsumptionDeduction === 0">-</span>
              <span v-else-if="scope.row.UserSource === 2 || scope.row.UserSource === 0">-{{ scope.row.ConsumptionDeduction }}</span>
              <span v-else>{{ scope.row.ConsumptionDeduction }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" :formatter="formatData" show-overflow-tooltip prop="BalanceReduction" label="余额核减" min-width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.BalanceReduction === 0">-</span>
              <!-- <span v-else-if="scope.row.UserSource === 1 || scope.row.UserSource === 0">-{{ scope.row.BalanceReduction }}</span> -->
              <span v-else>{{ scope.row.BalanceReduction }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" :formatter="formatData" show-overflow-tooltip prop="RebateReduction" label="返点核减" min-width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.RebateReduction === 0">-</span>
              <!-- <span v-else-if="scope.row.UserSource === 1 || scope.row.UserSource === 0">-{{ scope.row.RebateReduction }}</span> -->
              <span v-else>{{ scope.row.RebateReduction }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" :formatter="formatData" show-overflow-tooltip prop="CallbackAmount" label="回拨金额" min-width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.CallbackAmount === 0">-</span>
              <span v-else-if="scope.row.UserSource === 1" style="color: #8bc34a">+{{ scope.row.CallbackAmount }}</span>
              <span v-else-if="scope.row.UserSource === 2">-{{ scope.row.CallbackAmount }}</span>
              <span v-else>{{ scope.row.CallbackAmount }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" :formatter="formatData" show-overflow-tooltip prop="RefundAmount" label="退款金额" min-width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.RefundAmount === 0">-</span>
              <!-- <span v-else-if="scope.row.UserSource === 1 || scope.row.UserSource === 0">-{{ scope.row.RefundAmount }}</span> -->
              <span v-else>{{ scope.row.RefundAmount }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" :formatter="formatData" show-overflow-tooltip prop="BalanceAfter" label="账户余额" min-width="150">
          </el-table-column>
        </el-table>
        <!-- 分页显示 -->
        <el-pagination background layout="prev, pager, next" :total="dataSize" :page-size="20" :current-page="currentPage" @current-change="pageChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
// 面包屑
import crumbs from "../public/crumbs/newCrumbs";
// 工具函数
import { formatDateAll, formatDate } from "common/js/common";
// api
import { GetFinancialRecordList, GetSalerUserList } from "api/mediaWithdraw";

export default {
  data() {
    return {
      searchData: {
        UserId: "",
        PaymentAccount: "",
        OrgCode: "-1",
        SalesmanId: "-1",
        UserSource: "-1",
        DataType: "-1",
        applyTime: []
      },
      trails: [
        {
          trail: "财务管理",
          href: ""
        },
        {
          trail: "广告主财务流水",
          href: ""
        }
      ],
      dataSize: 0,
      currentPage: 1430,
      salerUserList: [],
      tableData: [],
      maxTableHeight: null
    };
  },
  computed: {
    exportUrl() {
      var filterData = {
        UserId: this.searchData.UserId,
        PaymentAccount: this.searchData.PaymentAccount,
        OrgCode: this.searchData.OrgCode,
        SalesmanId: this.searchData.SalesmanId,
        UserSource: this.searchData.UserSource,
        DataType: this.searchData.DataType,
        BeginDate: this.searchData.applyTime
          ? this.searchData.applyTime[0]
          : "",
        EndDate: this.searchData.applyTime ? this.searchData.applyTime[1] : ""
      };
      var url = `/IAD_AdrFinancialFlow/ExportFinancialRecord?_t=${new Date().getTime()}`;
      for (var key in filterData) {
        url += `&${key}=${filterData[key] ? filterData[key] : ""}`;
      }
      return url;
    }
  },
  components: {
    crumbs
  },
  methods: {
    // 获取媒体运营数据
    initData() {
      GetSalerUserList().then(res => {
        this.salerUserList = Object.assign({}, this.salerUserList, res.list);
      });
      const end = new Date();
      const start = new Date();
      this.searchData.applyTime.push(formatDate(start));
      this.searchData.applyTime.push(formatDate(end));
    },
    // 获取媒体提现申请数据
    getFinancialRecordList(type) {
      if (type) {
        this.currentPage = 1;
      }
      var filterData = {
        PageIndex: this.currentPage,
        PageSize: 20,
        UserId: this.searchData.UserId,
        PaymentAccount: this.searchData.PaymentAccount,
        OrgCode: this.searchData.OrgCode,
        SalesmanId: this.searchData.SalesmanId,
        UserSource: this.searchData.UserSource,
        DataType: this.searchData.DataType,
        BeginDate: this.searchData.applyTime
          ? this.searchData.applyTime[0]
          : "",
        EndDate: this.searchData.applyTime ? this.searchData.applyTime[1] : ""
      };
      GetFinancialRecordList(filterData)
        .then(res => {
          if (res.list) {
            this.tableData = res.list;
            this.dataSize = res.count;
          } else {
            this.tableData = [];
            this.dataSize = 0;
          }
        })
        .catch(err => {
          this.tableData = [];
          this.dataSize = 0;
        });
    },
    // 格式化时间
    formatDater(row, column, cellValue, index) {
      return formatDateAll(cellValue);
    },
    // 处理空值
    formatData(row, column, cellValue, index) {
      if (cellValue) {
        return cellValue;
      } else {
        return "-";
      }
    },
    // 分页切换页码
    pageChange(currentPage) {
      this.currentPage = currentPage;
      this.getFinancialRecordList();
    }
  },
  created() {
    document.title = "广告主财务流水";
    this.initData();
    this.getFinancialRecordList();
  },
  mounted() {
    let that = this;
    window.onscroll = () => {
      var height = that.$refs.crumbs.$el.offsetHeight + that.$refs.searchData.offsetHeight + that.$refs.dataType.offsetHeight + 50;
      if(window.scrollY > height) {
        that.maxTableHeight = window.innerHeight -88;
      }else {
        that.maxTableHeight = null;
      }
    }
  }
};
</script>
<style>
.navbar {
  min-height: none;
  max-height: 50px;
}
ul.nav {
  padding: 0 !important;
}
#navbar .sign-in-wrap {
  padding-right: 50px !important;
}
.launchTime .el-date-editor .el-range-separator {
  width: 10% !important;
}
#edui1_iframeholder {
  max-height: 177px !important;
  overflow: auto !important;
}
.money-icon {
  margin-right: 5px !important;
}
.areaWindow .el-dialog {
  width: 940px !important;
  margin-top: 4vh !important;
}
.areaWindow .el-dialog__body {
  padding: 8px 32px 75px !important;
}
.putonArea .region {
  margin-top: 4px !important;
}
.putonArea .region .provinces-group {
  width: 650px !important;
}
.putonArea .region .provinces-group .provinces {
  border: 1px solid transparent;
}
.putonArea .region .provinces-group .provinces .cities-group {
  max-height: 150px !important;
  font-size: 14px !important;
  border: 1px solid #ccc !important;
  border-left: none !important;
}
.putonArea .region .provinces-group .provinces.mouseon .cities-group .cities {
  border-right: none !important;
  border-bottom: none !important;
}
.el-select-dropdown__wrap {
  margin-right: -71px !important;
}
</style>
<style lang="scss">
@import "../../common/scss/color.scss";
.financial-flow {
  .filter-search {
    border: 1px solid #f2f2f2;
    padding: 20px 15px;
    .el-form-item {
      vertical-align: middle;
      .el-date-editor {
        width: 250px;
      }
      .el-button {
        vertical-align: middle;
        min-width: 94px;
      }
      .el-form-item__content {
        vertical-align: middle;
      }
      .export-button {
        vertical-align: middle;
        width: 94px;
        display: inline-block;
        color: #fff;
        background-color: #5798d7;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        border: 1px solid #5798d7;
        text-align: center;
        box-sizing: border-box;
        outline: 0;
        margin-left: 10px;
        padding: 9px 15px;
        font-size: 12px;
        border-radius: 4px;
        &:hover {
          background: #66b1ff;
          border-color: #66b1ff;
          color: #fff;
        }
      }
    }
  }
  .data-type {
    padding: 15px;
    .data-size {
      color: #bbbbbb;
      font-size: 14px;
    }
    .el-icon-menu:before {
      font-size: 18px;
      vertical-align: middle;
    }
  }
  .data-list {
    thead {
      tr {
        background-color: #f5f5f5 !important;
        border-bottom: 2px solid #bbb;
        text-align: center;
      }
    }
    .el-pagination {
      height: 28px;
      text-align: center;
      margin: 30px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/financial-management/financial-flow.vue